export const FETCH_STATUS = {
    SUCCESS: 'success',
    PENDING: 'pending',
    FAIL: 'fail',
};
export const PUBLISHED = 'published';
export const UNPUBLISHED = 'un' + PUBLISHED;
export const PAGE_SIZE = 100;
